<template>
  <section id="contact" class="n2-seccion n2-seccion--contacto" :class="{ 'n2-seccion--contacto-titulo': conTitulo }">
    <div class="n2-contenedor">
      <!-- Cabecera con el título de la página Contacto del panel, solo si la plantilla la pide (diseño 3, ref: https://trello.com/c/wWr9VZJX).
           Con formulario debajo no se pone: ya lleva su propio título y saldría repetido (ref: https://trello.com/c/cmn3Bi3L) -->
      <div v-if="conTitulo && !NOTARIA.Theme.Home.Form?.Mostrar" class="n2-cabeza-seccion n2-aparece">
        <h2 class="n2-titulo-seccion" v-html="tituloSeccion(NOTARIA, 'Contacto', $t)"></h2>
      </div>
      <div class="n2-datos-contacto">
        <a v-if="C.Direccion" class="n2-dato n2-aparece" :href="C.EnlaceMaps || undefined" target="_blank" rel="noopener">
          <v-icon>mdi-map-marker-outline</v-icon>
          <span><strong>{{ C.Direccion }}</strong><br>{{ [C.CP, C.Municipio].filter(Boolean).join(' ') }}</span>
        </a>
        <a v-if="C.Telefono" class="n2-dato n2-aparece" :href="'tel:' + C.Telefono.replace(/\s/g, '')">
          <v-icon>mdi-phone-outline</v-icon>
          <span><strong>{{ C.Telefono.trim() }}</strong><br>{{ C.Email }}</span>
        </a>
        <div v-if="C.Horario" class="n2-dato n2-aparece">
          <v-icon>mdi-clock-outline</v-icon>
          <span>
            <strong>{{ NOTARIA.Theme.Footer?.TituloHorario?.Texto || tSolicitud('Horario') }}</strong>
            <span v-if="abierto !== null" class="n2-estado" :class="abierto ? 'n2-estado--abierto' : 'n2-estado--cerrado'">
              <span class="n2-estado__punto"></span>{{ tSolicitud(abierto ? 'Abierto ahora' : 'Cerrado ahora') }}
            </span>
            <br><span class="n2-pre">{{ C.Horario }}</span>
          </span>
        </div>
      </div>
    </div>

    <!-- Formulario de Inicio → Formulario de contacto, con el diseño elegido en el panel -->
    <div v-if="NOTARIA.Theme.Home.Form?.Mostrar" class="n2-formulario">
      <ContactFormGuiado v-if="NOTARIA.Theme.Home.Form.Design === 2" :contactForm="style.ThemeHomeFormContact" />
      <ContactFormPersonalizado v-else-if="NOTARIA.Theme.Home.Form.Design === 3" :contactForm="style.ThemeHomeFormContact" />
      <ContactFormNotinTwo v-else-if="NOTARIA.Theme.Home.Form.Design === 1 || NOTARIA.Theme.Home.Form.Design == null" :contactForm="style.ThemeHomeFormContact" />
      <ContactFormNotinOne v-else :contactForm="style.ThemeHomeFormContact" />
    </div>
  </section>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue'
import { storeToRefs } from 'pinia'
import { useStore } from '../../store/index'
import { useStyles } from '../../store/styles'
import { t as tSolicitud } from '../../composables/solicitudTextos'
import { abiertoAhora, tituloSeccion } from '../../composables/useNotaria2'
import { useUtils } from '#imports'

defineProps({ conTitulo: { type: Boolean, default: false } })

const store = useStore()
const { NOTARIA } = storeToRefs(store)
const style = useStyles()
const { $t } = useUtils()
const C = computed(() => NOTARIA.value?.Contacto ?? {})
const abierto = ref(null)
onMounted(() => { abierto.value = abiertoAhora(C.value.HorarioEstructurado) })
</script>
